/**
 * EmptyState — soft "no records" placeholder for tables, lists, and panels.
 * Mono uppercase eyebrow over an Inter sentence + optional CTA. Pairs with
 * `<DataTable empty>` and inspector panels.
 *
 * Not present in the artboards — extrapolated within the language.
 */

import type { ReactNode } from 'react';

interface EmptyStateProps {
  /** Mono uppercase eyebrow (e.g. "Bez záznamů"). */
  eyebrow?: ReactNode;
  /** Inter title sentence. */
  title: ReactNode;
  /** Optional secondary description. */
  description?: ReactNode;
  /** Optional CTA — typically a `<Button>`. */
  action?: ReactNode;
  className?: string;
}

export function EmptyState({
  eyebrow,
  title,
  description,
  action,
  className = '',
}: EmptyStateProps) {
  return (
    <div
      className={
        'grid place-items-center px-8 py-16 text-center ' + className
      }
    >
      <div className="max-w-md">
        {eyebrow && (
          <div className="mb-3 font-mono text-[10px] uppercase tracking-[0.1em] text-ink-3">
            {eyebrow}
          </div>
        )}
        <p className="text-[15px] leading-[1.45] text-ink">{title}</p>
        {description && (
          <p className="mt-2 text-[12.5px] leading-[1.55] text-ink-3">
            {description}
          </p>
        )}
        {action && <div className="mt-5">{action}</div>}
      </div>
    </div>
  );
}
